<template>
<div class="slide-fuel">
    <div class="page__header">
        <div class="search-question" data-step="3">Your preferred fuel type?</div>
    </div>
    <div class="page__content">
        <div class="fuel__option" @click="filterByFuel('gas')">
            <div class="fuel-icon"><img src="static/icon-fire.png" alt="" /></div>
            <img class="fuel" src="static/gas.png" alt="Gas"/>
            <div class="info">
                <h3>All Gas</h3>
                <hr />
                <ul>
                    <li>Gas Hob</li>
                    <li>Gas Grill</li>
                    <li>Gas Ovens</li>
                </ul>
                <button class="information" @click="toggleGasTooltip">
                    <i class="fas fa-info-circle"></i>
                    Information
                    <span v-if="tooltip.gas">*RH oven on 90cm and 100cm is fanned electric (13amp)</span>
                </button>
            </div>
        </div>
        <div class="fuel__option" @click="filterByFuel('dual')">
            <div class="fuel-icon"><img src="static/icon-dual-fuel.png" alt="" /></div>
            <img class="fuel" src="static/dual-fuel.png" alt="Dual Fuel"/>
            <div class="info">
                <h3>Dual fuel</h3>
                <hr />
                <ul>
                    <li>Gas Hob</li>
                    <li>Electric Grill</li>
                    <li>Electric Ovens</li>
                </ul>
            </div>
        </div>
        <div class="fuel__option" @click="filterByFuel('induction')">
            <div class="fuel-icon"><img src="static/icon-electric.png" alt="" /></div>
            <img class="fuel" src="static/induction.png" alt="Induction"/>
            <div class="info">
                <h3>Induction</h3>
                <hr />
                <ul>
                    <li>Electric Induction Hob</li>
                    <li>Electric Grill</li>
                    <li>Electric Ovens</li>
                </ul>
                <button v-if="!isWebApp" class="information" @click="toggleVideoTooltip">
                    <i class="fas fa-play-circle"></i>
                    Why Choose Induction?
                </button>
            </div>
        </div>
        <div class="fuel__option" @click="filterByFuel('ceramic')">
            <div class="fuel-icon"><img src="static/icon-electric.png" alt="" /></div>
            <img class="fuel" src="static/ceramic.png" alt="Ceramic"/>
            <div class="info">
                <h3>Ceramic</h3>
                <hr />
                <ul>
                    <li>Electric Ceramic Hob</li>
                    <li>Electric Grill</li>
                    <li>Electric Ovens</li>
                </ul>
            </div>
        </div>
    </div>
    <video-modal src="/static/Induction.mp4" @click="toggleVideoTooltip" v-if="tooltip.video"/>
</div>
</template>
<script>
import { isWebApp } from "../../api/index.js";
export default {
    data: function(){
        return {
            tooltip: {
                gas: false,
                video: false
            },
            isWebApp: isWebApp()
        }
    },
    methods: {
        filterByFuel(fuel){
            this.$ga.event('filter', 'fuel', fuel);
            this.$router.push({ name: 'function', params: { ...this.$route.params,fuel } })
        },
        toggleGasTooltip(ev){
            ev.preventDefault();
            ev.stopPropagation();
            this.tooltip.gas = !this.tooltip.gas;
        },
        toggleVideoTooltip(ev){
            ev.preventDefault();
            ev.stopPropagation();
            this.tooltip.video = !this.tooltip.video;
        }
    },
  mounted(){
    this.$ga.screenview('fuel');
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/slide-3-fuel.vue